import apiClient from './apiClient';

const notificationApi = {
  getNotifications: async (params = {}) => {
    return apiClient.get('/notifications', { params });
  },

  markAsRead: async (id) => {
    return apiClient.put(`/notifications/${id}/read`, {});
  },

  markAllAsRead: async () => {
    return apiClient.put('/notifications/read-all', {});
  },
};

export default notificationApi;
